
export default {
  align: 'center',
  emptyBtn: false,
  submitBtn:false,
  submitText: '审批通过',
  column: [
    {
      label: "主键id",
      prop: "id",
      display:false,

    },

    // {
    //   label: "审批",
    //   prop: "approveStatus",
    //   type: "radio",
    //   span:24,
    //   rules: [
    //     {
    //       required: true,
    //       message: "请选择是否通过审批",
    //       trigger: "change",
    //     },
    //   ],
    //   dicData: [
    //     {label: "审批通过", value: "1"},
    //     {label: "审批不通过", value: "2"},
    //   ],
    //   props: {
    //     label: "label",
    //     value: "value",
    //   },
    // },
    {
      label: "操作内容",
      prop: "description",
      formslot:true,
      span: 24,
      type: 'textarea',
      minRows: 6,
      maxlength: 500,
      rules: [
        {
          required: false,
          message: "请输入回访内容",
          trigger: "change"
        }
      ]
    },
  ],
};

